export default {
  improvementplans: {
    title: '改进计划',
    high: '高',
    middle: '中',
    low: '低',
    exceed: '超过',
    policy: '规范·方针',
    measure: '措施',
    result: '结果',
    currently_supporting: '正在进行中',
    completion: '结束',
    ended: '结束(未进行)',
    risk: '风险',
    thema: "@:{'common.esg.category'}",
    improvement_plan: '改进计划',
    deadline_for_completion: '完成期限',
    message_count: '信息',
    operation: '操作',
    detail: "@:{'common.scorecard.detail'}",
    indicator: '指标',
    indicator_point: '建议',
    buyer_indicator_point: '评估意见',
    status: '状态',
    supported: '已完成',
    unsupported: '未进行',
    progress: '进度',
    advice: {
      text_line_1: '立足于本次评估，推进更好的ESG措施。',
      text_line_2: "您可以查看建议的@:{'common.esg.category'}和内容，",
      text_line_3: '并通过“创建改进计划”设置改进内容和完成日期。',
      text_line_4: '制定改进计划，为下一次评估做好准备。',
      text_line_5: '可以通过左侧的图表查看进度。',
      text_line_6: '如需重新评估，请',
      contact: '联系我们',
      please_contact_us: '。',
    },
    sub_section_title_1: '正在进行的改进计划',
    no_data_display: '没有可显示的数据。',
    sub_section_title_2: '未采取措施的建议',
    buyer_sub_section_title_2: '未处理的评估意见',
    operation_link_text: '创建改进计划',
    add_advice: '添加建议',
    sub_section_title_3: '已采取措施的建议',
    buyer_sub_section_title_3: '已处理的评估意见',
    revaluation_request: '委托重新评估',
    cautionary_note: '是否希望依据已完成的改进计划重新进行评估？',
    asterisked_text: '※如要重新评估，需通过“联系我们”页面另行申请。',
    submit_btn_text: '委托重新评估',
    table_state: 'tableState',
    select_a_file: '选择文件',
    attached_file: '附件',
    notes: '备注',
    created_improvement_plan: '改进计划已创建。',
    error_file_upload: '发生文件上传错误。',
    failed_to_create: '改进计划创建失败。请尝试重新读入页面。',
    no_data_found: '未找到改进建议的数据。',
    file_upload: {
      filesize_max: '请选择10MB以下的文件。',
      max_files: '最多可上传10个文件。',
      confirmation_of_deletion: '删除此文件？',
    },
    create_improvement_plan: '创建改进计划',
    no_data_improvement_plan: '目前没有需要应对的改进计划',
  },
  buyer_improvementplans: {
    flag: '标记',
    memo: '备忘录',
    flag_on: '添加标记',
    flag_off: '删除标记',
    panel: {
      title: '企业信息/备忘录',
      company_memo: '内部备忘录',
      latest_memo: '最新备忘录',
      no_memo: '还没有备忘录。',
      check_list: '确认列表',
      memo_list: '备忘录列表',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: '返回列表',
    action_cases: '处理件数',
    no_improvements: '没有改进',
    confirm_delete_memo: '您要删除1份内部备忘录吗？',
    confirm_delete_memo_title: '删除内部备忘录',
    // display_only_is_marked: "",
    create_memo: '创建备忘录',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
